import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { signOut } from '../state/auth';
import { colors } from '../styles/colors';

export const SignOut = ({ className }) => {
   const intl = useIntl();
   const dispatch = useDispatch();

   const out = () => {
      dispatch(signOut());
   };

   return (
      <Wrapper>
         <Button className={className} type="button" onClick={out}>
            {intl.formatMessage({ id: 'SignOut' })}
         </Button>
      </Wrapper>
   );
};

const Wrapper = styled.div`
   position: relative;
`;

const Button = styled.button`
   line-height: 40px;
   height: 40px;
   border: none;
   margin-left: 20px;
   padding: 0;
   display: block;
   min-width: 120px;
   text-align: center;
   background: ${colors.primary};
   color: ${colors.white};
   font-weight: 600;
   border-radius: 20px;
`;
